angular.module('nv.shared.modals').factory('ConfirmationModal', ConfirmationModal);

function ConfirmationModal($mdDialog, $analytics) {
  return {
    show(title, textContent, affirmationText, showCancelBtn = true) {
      affirmationText = affirmationText || 'OK';
      const confirm = $mdDialog
        .confirm()
        .title(title)
        .textContent(textContent)
        .ok(affirmationText);

      if (showCancelBtn) {
        confirm.cancel('CANCEL');
      }
      return $mdDialog.show(confirm).then(() => {
        $analytics.eventTrack('confirm', { category: title });
      });
    },
  };
}
